module.exports = __webpack_public_path__ + "static/media/p0gif.f32843a9.gif";